import { Skeleton } from '@accure/ui';

export function FiltersLoading() {
  return (
    <div className="flex flex-row gap-4">
      {[1, 2].map((i) => (
        <div key={i} className="flex flex-col gap-1">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-9 w-60" />
        </div>
      ))}
    </div>
  );
}
